import { Component } from '@angular/core';
import { DefaultSidebarComponent } from '../default-sidebar/default-sidebar.component';
import { DefaultHeaderComponent } from '../default-header/default-header.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-default-body',
  templateUrl: './default-body.component.html',
  styleUrls: ['./default-body.component.scss'],
  standalone: true,
  imports: [DefaultSidebarComponent, CommonModule, DefaultHeaderComponent,RouterModule, NgbModule, NgbDropdownModule],
  providers:[]
})
export class DefaultBodyComponent {

}
